import service from '@/utils/request'; // CreateBairunPayChannel 添加百润支付方式
// @Tags Bairun
// @Summary 添加百润支付方式
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunPayChannelRequest true "添加百润支付方式"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /payChannel/create [post]

export var createBairunPayChannel = function createBairunPayChannel(data) {
  return service({
    url: '/payChannel/create',
    method: 'post',
    data: data
  });
}; // DeleteBairunPayChannel 删除百润支付方式
// @Tags Bairun
// @Summary 删除百润支付方式
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunPayChannel true "删除百润支付方式"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /payChannel/delete [delete]

export var deleteBairunPayChannel = function deleteBairunPayChannel(data) {
  return service({
    url: '/payChannel/delete',
    method: 'post',
    data: data
  });
}; // DeleteBairunPayChannelByIds 批量删除百润支付方式
// @Tags Bairun
// @Summary 批量删除百润支付方式
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除百润支付方式"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /payChannel/deleteByIds [delete]

export var deleteBairunPayChannelByIds = function deleteBairunPayChannelByIds(data) {
  return service({
    url: '/payChannel/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateBairunPayChannel 更新百润支付方式
// @Tags Bairun
// @Summary 更新百润支付方式
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunPayChannel true "更新百润支付方式"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /payChannel/update [put]

export var updateBairunPayChannel = function updateBairunPayChannel(data) {
  return service({
    url: '/payChannel/update',
    method: 'put',
    data: data
  });
}; // FindBairunPayChannel 查找单个百润支付方式的信息
// @Tags Bairun
// @Summary 查找单个百润支付方式的信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunPayChannel true "查找单个百润支付方式的信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /payChannel/find [get]

export var findBairunPayChannel = function findBairunPayChannel(params) {
  return service({
    url: '/payChannel/find',
    method: 'get',
    params: params
  });
}; // GetBairunPayChannelList 分页获取百润支付方式的数据
// @Tags Bairun
// @Summary 分页获取百润支付方式的数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.BairunPayChannelSearch true "分页获取百润支付方式的数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /payChannel/getList [get]

export var getBairunPayChannelList = function getBairunPayChannelList(params) {
  return service({
    url: '/payChannel/getList',
    method: 'get',
    params: params
  });
};